module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ui_title_line', {
    attrs: {
      "no_left": ""
    }
  }, [_vm._v("\n      О СЕРВИСЕ\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row row-logo-with-text"
  }, [_c('div', {
    staticClass: "col-12 col-md-8 offset-md-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col padd-mobile"
  }, [_c('ui_sub_title_text', [_vm._v("\n              Сервис «Мобильный адвокат» — уникальная площадка по поиску адвокатских услуг в России\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ui_text', [_c('p', [_vm._v("\n                На нашем портале Вы можете найти проверенного адвоката с любой специализацией в Вашем городе. Гарантом выполнения услуг выступает «Безопасная сделка». Вы можете не беспокоиться о деньгах: специалист получит их после выполнения всех обязательств. С другой стороны, адвокат спокоен за оплату своих услуг: деньги хранятся на безопасном счету до завершения сделки\n              ")])])], 1), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col offset-md-2 col-md-8"
  }, [_c('div', {
    staticClass: "row row-two-colm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row row-img-wrapp"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "title-col"
  }, [_c('ui_sub_title_text', [_vm._v("Уникальность")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-col"
  }, [_c('ui_text', [_vm._v("Портал, где можно быстро найти адвоката с любой специализацией")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row row-img-wrapp no-wrap-desc"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "title-col"
  }, [_c('ui_sub_title_text', [_vm._v("Конфиденциальность")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-col"
  }, [_c('ui_text', [_vm._v("Мы не вмешиваемся в Ваши договоренности. О Вашей сделке знаете только Вы и адвокат")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-two-colm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row row-img-wrapp"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "title-col"
  }, [_c('ui_sub_title_text', [_vm._v("Мы на связи")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-col"
  }, [_c('ui_text', [_vm._v("Круглосуточная поддержка. Мы поможем!")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row row-img-wrapp"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "title-col"
  }, [_c('ui_sub_title_text', [_vm._v("Безопасность")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-col"
  }, [_c('ui_text', [_vm._v("Мы сохраним Ваши деньги, пока адвокат не выполнит условия сделки")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-two-colm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row row-img-wrapp"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "title-col"
  }, [_c('ui_sub_title_text', [_vm._v("Надежность")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-col"
  }, [_c('ui_text', [_vm._v("Всех зарегистрированных адвокатов мы проверяем на присутствие в Министерстве Юстиции РФ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row row-img-wrapp"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "title-col"
  }, [_c('ui_sub_title_text', [_vm._v("Бесплатно")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-col"
  }, [_c('ui_text', [_vm._v("За пользование нашей площадкой мы не берем деньги с клиента")])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 padd-mobile"
  }, [_c('ui_title', [_vm._v("\n          НАШИ КОНТАКТЫ\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 padd-mobile offset-md-2"
  }, [_c('div', {
    staticClass: "row contact-info"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('ui_text', [_c('img', {
    attrs: {
      "src": "/static/img/icon_phone.svg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+74956425292"
    }
  }, [_vm._v("+7 (495) 64 25 292")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row contact-info"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('ui_text', [_c('img', {
    attrs: {
      "src": "/static/img/icon_mail_dark.svg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto: info@mobileadvokat.ru"
    }
  }, [_vm._v("info@mobileadvokat.ru")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row contact-info"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('ui_text', [_vm._v("с 10.00 до 18.00 по МСК, Пн-Пт")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 padd-mobile"
  }, [_c('ui_title', [_vm._v("\n        РЕКВИЗИТЫ\n      ")]), _vm._v(" "), _c('ui_text', [_vm._v("ООО «ОМТ СОФТ»")]), _vm._v(" "), _c('ui_text', [_vm._v("ИНН 9710008096")]), _vm._v(" "), _c('ui_text', [_vm._v("ОГРН 1167746187058")]), _vm._v(" "), _c('ui_text', [_vm._v("117105, город Москва, Варшавское шоссе, дом 1, строение 1-2, этаж 6, комната 33")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-4 logo-img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/newLogo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 col-img"
  }, [_c('img', {
    staticClass: "img-150",
    attrs: {
      "src": "/static/img/loop.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-3 col-img"
  }, [_c('img', {
    staticClass: "img-150",
    attrs: {
      "src": "/static/img/hands.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-3 col-img"
  }, [_c('img', {
    staticClass: "img-150",
    attrs: {
      "src": "/static/img/clock.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-3 col-img"
  }, [_c('img', {
    staticClass: "img-150",
    attrs: {
      "src": "/static/img/dollars.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-3 col-img"
  }, [_c('img', {
    staticClass: "img-150",
    attrs: {
      "src": "/static/img/ves.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-3 col-img"
  }, [_c('img', {
    staticClass: "img-150",
    attrs: {
      "src": "/static/img/bm.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76559e79","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Service/service.vue
// module id = 363
// module chunks = 2